<div class="blog-top">  
  <div class="container top-title">
  <div class="title">Kurumsal</div>
  <div class="b-title">
    <div class="slogan">Misyon ve Vizyonumuz</div>
  </div>
</div></div>
<div class="container">


  <div class="row">
    <div class="col-md-3">
      <div class="Rectangle-33">
        <ul>
          <li><a routerLink="hakkimizda">Hakkımızda</a></li>
          <li><a routerLink="/sikca-sorulan-sorular">Sıkça Sorulan Sorular</a></li>
          <li><a routerLink="/politikalar-ve-kvkk-dokumanlari/hukum-ve-kosullar"> Hüküm ve Koşullar</a></li>
          <li><a routerLink="/politikalar-ve-kvkk-dokumanlari/aydinlatma-metni">Aydınlatma Metni</a></li>
          <li><a routerLink="/politikalar-ve-kvkk-dokumanlari/hukum-ve-kosullar">İptal ve İade Koşulları </a></li>
          <li><a routerLink="/iletisim">İletişim</a></li>
        </ul>
      </div>
    </div>
    <div class="col-md-9">

      <h3>{{ about?.title }}</h3>
      <div [innerHTML]="about?.content"></div>
    </div>
  </div>


</div>